import styled from 'styled-components';
import { px2rem } from '../../../../stylesheets/tools';

const StyledEducationQuickFact = styled.section`
  display: flex;
  flex-direction: column;
  gap: ${px2rem('6px')};
  padding: ${px2rem('25px')};
  border-radius: ${px2rem('2px')};
  background-position: top right, top right, bottom left, bottom left, top left;
  background-repeat: no-repeat;
  background-image: linear-gradient(180deg, #e8e8e8, #e8e8e8),
    linear-gradient(225deg, #e8e8e8, #e8e8e8), linear-gradient(0deg, #e8e8e8, #e8e8e8),
    linear-gradient(90deg, #e8e8e8, #e8e8e8),
    linear-gradient(135deg, transparent 14px, #e8e8e8 14px, #e8e8e8 16px, transparent 16px);
  background-size: calc(100% - 20px) 2px, 2px 100%, 100% 2px, 2px calc(100% - 20px), 36px 36px;

  .quick-fact__headline {
    margin-bottom: ${px2rem('15px')};
    font-size: ${px2rem('20px')};
  }

  .quick-fact__person-copy {
    margin: 0;
  }

  .quick-fact__content {
    display: flex;
    flex-direction: column;
    align-items: start;
    gap: ${px2rem('8px')};

    .quick-fact__copy {
      margin: 0;

      ul,
      ol {
        margin: 0;
        width: 100%;
      }
      ol li::marker {
        font-weight: bold;
      }
    }
    .quick-fact__link-inner {
      display: flex;
      gap: ${px2rem('8px')};

      .quick-fact__icon {
        margin-top: ${px2rem('4px')};
        display: flex;
        justify-content: center;
      }

      span {
        text-decoration: solid underline ${px2rem('2px')};
        text-underline-offset: ${px2rem('4px')};
        word-break: break-all;
      }
    }
  }
`;

export default StyledEducationQuickFact;
